import React from 'react';
import './App.css';
import FormDashboard from "./container/FormDashboard"
function App() {
  return (
    <div className="App">
    <FormDashboard />
    </div>
  );
}

export default App;
